import { render, staticRenderFns } from "./ValidationNotification.vue?vue&type=template&id=07becbfd"
import script from "./ValidationNotification.vue?vue&type=script&lang=js"
export * from "./ValidationNotification.vue?vue&type=script&lang=js"
import style0 from "./ValidationNotification.vue?vue&type=style&index=0&id=07becbfd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports